export default "/assets/images/icon-support.091595240950e5aa.svg";